/*
  batida-v7-menu.js - the new batida.pl phone menu (Aleksandra's "Menu na telefonie (wzór)", 29.09).
  Markup: snippets/batida-v7-phone-menu.liquid inside the header's <nav data-drawer="hamburger" class="v7-pm">.
  Opening, closing, Esc, the focus trap and the scroll lock stay with Pipeline (theme.js, Drawer). This file only adds:
  - "Menu" / "O nas" (<details>): one open at a time, and the last opened one stays open next time (her spec:
    "ostatnio otwarta sekcja zostaje otwarta"); closing all is remembered too. First visit: the first one is open.
  - the "Dostawa: …" chip closes the menu before the city/postcode popup opens (snippets/zip-code-validator opens it),
    so the popup is on top and the page scroll lock is the popup's.
  - aria-expanded on the hamburger follows the menu (theme.js leaves it "true" after closing) and html gets
    .v7-pm-open while the menu is open (batida-v7-menu.css hides floating buttons under the dimmed page).
  batida.pl only (the class v7-pm exists only there). Revert: stop loading this file (sections/header.liquid).
*/
(function () {
  var nav = document.getElementById('header-menu');
  if (!nav || !nav.classList.contains('v7-pm')) return;

  var KEY = 'batida_v7_menu_open';
  var accs = [].slice.call(nav.querySelectorAll('details.v7-pm__acc'));

  function save(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }
  function load() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }

  var stored = load();
  if (stored !== null && accs.length) {
    var known = accs.some(function (d) { return d.getAttribute('data-v7pm-acc') === stored; });
    if (known || stored === '') {
      accs.forEach(function (d) { d.open = d.getAttribute('data-v7pm-acc') === stored; });
    }
  }

  accs.forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (d.open) {
        accs.forEach(function (o) { if (o !== d && o.open) o.open = false; });
        save(d.getAttribute('data-v7pm-acc'));
      } else if (!accs.some(function (o) { return o.open; })) {
        save('');
      }
    });
  });

  // The delivery chip: close the menu first (capture phase, before the popup's own click handler runs).
  nav.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.batida-loc-btn')) {
      nav.dispatchEvent(new CustomEvent('theme:drawer:close', { bubbles: false }));
    }
  }, true);

  // Keep aria-expanded + an html class in step with the menu. On opening, focus goes to the close button: theme.js
  // means to do that ([data-first-focus]) but looks it up with a broken selector, so focus stayed on the page behind
  // and Esc (theme.js listens inside the menu only) did nothing. Esc is handled here while the menu is open.
  var toggles = [].slice.call(document.querySelectorAll('[data-drawer-toggle="hamburger"]'));
  var closeBtn = nav.querySelector('.v7-pm__x');
  var wasOpen = false;
  function sync() {
    var open = nav.classList.contains('drawer--visible');
    toggles.forEach(function (b) { if (!nav.contains(b)) b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    document.documentElement.classList.toggle('v7-pm-open', open);
    if (open && !wasOpen && closeBtn) {
      setTimeout(function () {
        if (nav.classList.contains('drawer--visible') && !nav.contains(document.activeElement)) {
          try { closeBtn.focus({ preventScroll: true }); } catch (e) { closeBtn.focus(); }
        }
      }, 380);
    }
    wasOpen = open;
  }
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Escape' || e.key === 'Esc') && nav.classList.contains('drawer--visible')) {
      nav.dispatchEvent(new CustomEvent('theme:drawer:close', { bubbles: false }));
    }
  });
  if ('MutationObserver' in window) {
    new MutationObserver(sync).observe(nav, { attributes: true, attributeFilter: ['class'] });
  }
  sync();
})();
